type PdfSelectListItemProps = {
  thumbnailUrl: string | null;
  fileName: string;
  pageCount: number;
  metaText: string;
  onClick: () => void;
  fallbackName?: string;
};

export default function PdfSelectListItem({
  thumbnailUrl,
  fileName,
  pageCount,
  metaText,
  onClick,
  fallbackName = "프레젠테이션",
}: PdfSelectListItemProps) {
  return (
    <button
      onClick={onClick}
      className="w-full bg-white rounded-lg border border-gray-200 px-3 py-2.5 flex items-center gap-3 hover:bg-gray-50 hover:border-gray-300 active:bg-gray-100 transition-all cursor-pointer text-left"
    >
      <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden">
        {thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt={fileName}
            className="w-full h-full object-contain"
          />
        ) : (
          <i className="ri-file-pdf-line text-lg text-gray-400"></i>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-medium text-gray-900 text-sm truncate">
          {fileName?.replace(".pdf", "") || fallbackName}
        </h3>
        <p className="text-xs text-gray-400 mt-0.5">
          {pageCount}P · {metaText}
        </p>
      </div>
      <i className="ri-arrow-right-s-line text-gray-300 flex-shrink-0"></i>
    </button>
  );
}
